// extracted by mini-css-extract-plugin
module.exports = {"navigation":"_1hZLQ","breadcrumbs":"EU1kn","shortBreadcrumbs":"_26ftZ","shortBreadcrumbsRTL":"_2CWH4","shortBreadcrumbsRtl":"_2CWH4"};